import React, { useState, useEffect } from "react";
import {
  Box,
  Input,
  Grid,
  Text,
  Checkbox,
  CheckboxGroup,
  Select,
  FormControl,
  Flex,
  FormLabel,
  Stack,
  Switch,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import Allocate_rightside from "./Allocate_rightside";
import {
  LoadScript,
  GoogleMap,
  Marker,
  InfoWindow,
} from "@react-google-maps/api"; // Import Google Maps components
import Allocate_teachers from "./Allocate_teachers";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Allocate_students = () => {
  const { id } = useParams();
  const [busStops, setBusStops] = useState([]); // Store bus stops from API
  const [selectedPickup, setSelectedPickup] = useState("");
  const [selectedDrop, setSelectedDrop] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [listType, setListType] = useState("students"); // State for selecting between students and teachers

  const [busFee, setBusFee] = useState("");
  const [dueDate, setdueDate] = useState("");
  const [selectedTripType, setSelectedTripType] = useState([]); // Add this line
  const [status, setStatus] = useState("1");

  useEffect(() => {
    const ifameData = document.getElementById("iframeId");
    const lat = 9.995201473118305;
    const lon = 76.56862537450849;
    ifameData.src = `https://maps.google.com/maps?q=${lat},${lon}&hl=es;&output=embed`;
  });

  // Fetch bus stops from API
  useEffect(() => {
    const fetchBusStops = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/bus/bus_route/list_stop_names.php?bus_route_id=${id}`
        );
        const data = await response.json();
        console.log("list_stop", data);

        if (data.success && Array.isArray(data.data)) {
          setBusStops(data.data);
        } else {
          console.error("Failed to fetch bus stops: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching bus stops: ", error);
      }
    };

    fetchBusStops();
  }, [id]);

  const tripType = selectedTripType.includes("two-way") ? "Two Way" : "One Way";

  // Prepare the selected data
  const selectedPickupStop = {
    stop_id: selectedPickup, // Passing the ID instead of stop_name
    start_date: startDate,
    end_date: endDate,
    bus_fee: busFee,
    due_date: dueDate,
    trip: tripType, // Use the trip type here
  };

  const selectedDropStop = {
    stop_id: selectedDrop, // Passing the ID instead of stop_name
    start_date: startDate,
    end_date: endDate,
    due_date: dueDate,
    bus_fee: busFee,
    trip: tripType, // Use the trip type here
  };

  console.log("Selected Pickup Stop:", selectedPickupStop);
  console.log("Selected Drop Stop:", selectedDropStop);

  const fetchBusFee = async () => {
    const payload = {
      pickup_location: selectedPickup || null,
      drop_location: selectedDrop || null,
      start_date: startDate,
      end_date: endDate,
    };

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/fee/calculate_fees.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      console.log("bus fee", data);

      if (data.success) {
        setBusFee(data.message.bus_fee); // Extract fee from message
       // setBusFee(data.message.split(":")[1]?.trim()); // Extract fee from message

      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Error fetching bus fee:", error);
    }
  };

  useEffect(() => {
    if (startDate && endDate && (selectedPickup || selectedDrop)) {
      fetchBusFee();
    }
  }, [selectedPickup, selectedDrop, startDate, endDate]);

  return (
    <Box>
      <Flex gap={8} flexDirection={{ base: "column", md: "row" }}>
        <Box
          flex="2"
          p={4}
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          width="100%"
        >
          {/* Transport Details Section */}
          <Grid templateColumns={{ base: "1fr", lg: "1fr 2fr" }} gap={8} mb={8}>
            <Box
              p={4}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="md"
              boxShadow="md"
            >
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Transport Details
              </Text>
              <FormControl
                display="flex"
                flexDirection="column"
                alignItems="end"
                mb={4}
              >
                <FormLabel>Status</FormLabel>
                <Switch
                  colorScheme="blue"
                  isChecked={status}
                  onChange={(e) => setStatus(e.target.checked)}
                />
                <Text fontSize="sm" color="gray.500">
                  Toggle the status to change the fine
                </Text>
              </FormControl>

              {/* Checkbox for trip type */}
              <FormControl mb={4}>
                <FormLabel>Trip Type</FormLabel>
                <CheckboxGroup
                  colorScheme="blue"
                  value={selectedTripType}
                  onChange={(values) => setSelectedTripType(values)}
                >
                  <Stack direction="row" spacing={4}>
                    <Checkbox value="single">Single Trip</Checkbox>
                    <Checkbox value="two-way">Two-Way Trip</Checkbox>
                  </Stack>
                </CheckboxGroup>
              </FormControl>

              {/* Grid layout for inputs */}
              <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
                <FormControl>
                  <FormLabel>Pick-Up</FormLabel>
                  <Select
                    placeholder="Select Pick-Up"
                    value={selectedPickup}
                    onChange={(e) => setSelectedPickup(e.target.value)}
                    focusBorderColor="teal.500"
                    isDisabled={
                      selectedTripType.includes("single") && selectedDrop !== ""
                    } // Disable Pick-Up if Single Trip is selected and Drop is chosen
                  >
                    {busStops.map((stop) => (
                      <option key={stop.id} value={stop.id}>
                        {stop.stop_name}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel>Drop</FormLabel>
                  <Select
                    placeholder="Select Drop"
                    value={selectedDrop}
                    onChange={(e) => setSelectedDrop(e.target.value)}
                    focusBorderColor="teal.500"
                    isDisabled={
                      selectedTripType.includes("single") &&
                      selectedPickup !== ""
                    } // Disable Drop if Single Trip is selected and Pick-Up is chosen
                  >
                    {busStops.map((stop) => (
                      <option key={stop.id} value={stop.id}>
                        {stop.stop_name}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel>Start Date</FormLabel>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    focusBorderColor="teal.500"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>End Date</FormLabel>
                  <Input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    focusBorderColor="teal.500"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Due Date</FormLabel>
                  <Input
                    type="date"
                    value={dueDate}
                    onChange={(e) => setdueDate(e.target.value)}
                    focusBorderColor="teal.500"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Bus Fee</FormLabel>
                  <Input
                    type="number"
                    value={busFee}
                    onChange={(e) => setBusFee(e.target.value)}
                    placeholder="Enter Bus Fee"
                    focusBorderColor="teal.500"
                    isReadOnly

                  />
                </FormControl>
              </Grid>
            </Box>

            {/* Google Map Section */}
            <Box>
              <div>
                <iframe id="iframeId" height="500px" width="100%"></iframe>
              </div>
            </Box>
          </Grid>

          <Box mt={0} >
            <FormControl position="absolute" top="610px">
              {/* <FormLabel>Filter for List</FormLabel> */}
              <Select
                value={listType}
                onChange={(e) => setListType(e.target.value)}
                focusBorderColor="teal.500"
                width="200px" // Adjust the width of the dropdown
              >
                <option value="students">Students List</option>
                <option value="teachers">Teachers List</option>
              </Select>
            </FormControl>

            {listType === "students" ? (
              <Allocate_rightside
                selectedPickupStop={selectedPickupStop}
                selectedDropStop={selectedDropStop}
                id={id}
              />
            ) : (
              <Allocate_teachers
                selectedPickupStop={selectedPickupStop}
                selectedDropStop={selectedDropStop}
                id={id}
                status={status}
              />
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default Allocate_students;
